const colorFor = (count) => {
  if (!count) return 'rgba(255,255,255,0.06)';
  if (count === 1) return '#0F6E56';
  if (count <= 3) return '#1D9E75';
  return '#00D2C8';
};

export default function ActivityCalendar({ activityData = {}, streakDays = 0, yearlyCount = 0 }) {
  // 364 nap, a maival bezárólag (megegyezik a CoursePage streak-logikájával)
  const days = [];
  const today = new Date();
  for (let i = 363; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(d.getDate() - i);
    const key = d.toISOString().split('T')[0];
    days.push({ date: d, key, count: activityData[key] || 0 });
  }

  // 52 oszlop × 7 nap; hónapcímke az oszlop fölött, ahol új hónap kezdődik
  const columns = [];
  let prevMonth = -1;
  for (let c = 0; c < 52; c++) {
    const colDays = days.slice(c * 7, c * 7 + 7);
    const first = colDays[0];
    const m = first ? first.date.getMonth() : -1;
    const monthLabel = first && m !== prevMonth
      ? first.date.toLocaleDateString('hu-HU', { month: 'short' })
      : '';
    if (first) prevMonth = m;
    columns.push({ days: colDays, monthLabel });
  }

  return (
    <div style={{
      background: 'rgba(255,255,255,0.03)',
      border: '0.5px solid rgba(255,255,255,0.08)',
      borderRadius: 12, padding: 20, marginBottom: 40,
    }}>
      <div style={{ overflowX: 'auto' }}>
        <div style={{ display: 'inline-block' }}>
          {/* Hónapnevek */}
          <div style={{ display: 'flex', marginBottom: 4 }}>
            {columns.map((col, c) => (
              <div key={c} style={{
                width: 12, marginRight: 2,
                fontSize: 9, color: 'rgba(255,255,255,0.35)',
                whiteSpace: 'nowrap', overflow: 'visible',
              }}>
                {col.monthLabel}
              </div>
            ))}
          </div>

          {/* Rács */}
          <div style={{ display: 'flex' }}>
            {columns.map((col, c) => (
              <div key={c} style={{ display: 'flex', flexDirection: 'column', marginRight: 2 }}>
                {col.days.map(day => (
                  <div
                    key={day.key}
                    title={`${day.date.toLocaleDateString('hu-HU', { year: 'numeric', month: 'short', day: 'numeric' })} — ${day.count} lecke`}
                    style={{
                      width: 12, height: 12, borderRadius: 3, marginBottom: 2,
                      background: colorFor(day.count),
                    }}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Lábléc */}
      <div style={{ marginTop: 14, display: 'flex', gap: 18, flexWrap: 'wrap', fontSize: 13, color: 'rgba(255,255,255,0.6)' }}>
        <span>🔥 <strong style={{ color: '#fff' }}>{streakDays}</strong> napos streak</span>
        <span>📚 <strong style={{ color: '#fff' }}>{yearlyCount}</strong> lecke az elmúlt évben</span>
      </div>
    </div>
  );
}
